/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgradeaccount1Inputs */

const en_upgradeaccount1 = /** @type {(inputs: Upgradeaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade account`)
};

const de_upgradeaccount1 = /** @type {(inputs: Upgradeaccount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu Business wechseln`)
};

/**
* | output |
* | --- |
* | "Upgrade account" |
*
* @param {Upgradeaccount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const upgradeaccount1 = /** @type {((inputs?: Upgradeaccount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgradeaccount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgradeaccount1(inputs)
	return de_upgradeaccount1(inputs)
});
export { upgradeaccount1 as "upgradeAccount" }